import { Suspense } from "react";

import { DashboardShell } from "@/features/Government Observer/dashboard-shell";
import { AnimalDashboard } from "@/features/Government Observer/animal-dashboard";
import { DashboardSkeleton } from "@/features/Government Observer/dashboard-skeleton";
import { useGetOfficialsAllAnimals } from "@/features/Admin/Admin.api.ts";

export default function GuestDashboardPage() {
  const { data } = useGetOfficialsAllAnimals();

  return (
    <div className="flex w-full min-h-screen overflow-x-hidden flex-col justify-center items-center z-100">
      <DashboardShell>
        <Suspense fallback={<DashboardSkeleton />}>
          <AnimalDashboard data={data} />
        </Suspense>
      </DashboardShell>
    </div>
  );
}
